import * as s from "react";
import { a as h } from "./index.stoqs9MZ.js";
import { P as R, d as M } from "./index.DMLWxr4u.js";
import { u as w } from "./index.B4ZV02se.js";
import { j as g } from "./jsx-runtime.DGlMoOmv.js";
function x(t) {
  const e = s.useRef(t);
  return s.useEffect(() => {
    e.current = t;
  }), s.useMemo(() => (...n) => e.current?.(...n), []);
}
function j(t) {
  const e = s.useRef(t);
  return s.useEffect(() => {
    e.current = t;
  }), s.useMemo(() => (...n) => e.current?.(...n), []);
}
function z(t, e = globalThis?.document) {
  const n = j(t);
  s.useEffect(() => {
    const o = (r) => {
      r.key === "Escape" && n(r);
    };
    return e.addEventListener("keydown", o, { capture: !0 }), () => e.removeEventListener("keydown", o, { capture: !0 });
  }, [n, e]);
}
var H = "DismissableLayer", m = "dismissableLayer.update", K = "dismissableLayer.pointerDownOutside", X = "dismissableLayer.focusOutside", C, B = s.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), T = s.forwardRef(
  (t, e) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: r,
      onFocusOutside: u,
      onInteractOutside: f,
      onDismiss: d,
      ...E
    } = t, a = s.useContext(B), [c, S] = s.useState(null), l = c?.ownerDocument ?? globalThis?.document, [, k] = s.useState({}), W = w(e, (i) => S(i)), p = Array.from(a.layers), [A] = [...a.layersWithOutsidePointerEventsDisabled].slice(-1), N = p.indexOf(A), b = c ? p.indexOf(c) : -1, _ = a.layersWithOutsidePointerEventsDisabled.size > 0, D = b >= N, U = $((i) => {
      const v = i.target, O = [...a.branches].some((y) => y.contains(v));
      !D || O || (r?.(i), f?.(i), i.defaultPrevented || d?.());
    }, l), P = q((i) => {
      const v = i.target;
      [...a.branches].some((y) => y.contains(v)) || (u?.(i), f?.(i), i.defaultPrevented || d?.());
    }, l);
    return z((i) => {
      b === a.layers.size - 1 && (o?.(i), !i.defaultPrevented && d && (i.preventDefault(), d()));
    }, l), s.useEffect(() => {
      if (c)
        return n && (a.layersWithOutsidePointerEventsDisabled.size === 0 && (C = l.body.style.pointerEvents, l.body.style.pointerEvents = "none"), a.layersWithOutsidePointerEventsDisabled.add(c)), a.layers.add(c), L(), () => {
          n && a.layersWithOutsidePointerEventsDisabled.size === 1 && (l.body.style.pointerEvents = C);
        };
    }, [c, l, n, a]), s.useEffect(() => () => {
      c && (a.layers.delete(c), a.layersWithOutsidePointerEventsDisabled.delete(c), L());
    }, [c, a]), s.useEffect(() => {
      const i = () => k({});
      return document.addEventListener(m, i), () => document.removeEventListener(m, i);
    }, []), /* @__PURE__ */ g.jsx(
      R.div,
      {
        ...E,
        ref: W,
        style: {
          pointerEvents: _ ? D ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: h(t.onFocusCapture, P.onFocusCapture),
        onBlurCapture: h(t.onBlurCapture, P.onBlurCapture),
        onPointerDownCapture: h(
          t.onPointerDownCapture,
          U.onPointerDownCapture
        )
      }
    );
  }
);
T.displayName = H;
var Y = "DismissableLayerBranch", F = s.forwardRef((t, e) => {
  const n = s.useContext(B), o = s.useRef(null), r = w(e, o);
  return s.useEffect(() => {
    const u = o.current;
    if (u)
      return n.branches.add(u), () => {
        n.branches.delete(u);
      };
  }, [n.branches]), /* @__PURE__ */ g.jsx(R.div, { ...t, ref: r });
});
F.displayName = Y;
function $(t, e = globalThis?.document) {
  const n = x(t), o = s.useRef(!1), r = s.useRef(() => {
  });
  return s.useEffect(() => {
    const u = (d) => {
      if (d.target && !o.current) {
        let E = function() {
          I(
            K,
            n,
            a,
            { discrete: !0 }
          );
        };
        const a = { originalEvent: d };
        d.pointerType === "touch" ? (e.removeEventListener("click", r.current), r.current = E, e.addEventListener("click", r.current, { once: !0 })) : E();
      } else
        e.removeEventListener("click", r.current);
      o.current = !1;
    }, f = window.setTimeout(() => {
      e.addEventListener("pointerdown", u);
    }, 0);
    return () => {
      window.clearTimeout(f), e.removeEventListener("pointerdown", u), e.removeEventListener("click", r.current);
    };
  }, [e, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function q(t, e = globalThis?.document) {
  const n = x(t), o = s.useRef(!1);
  return s.useEffect(() => {
    const r = (u) => {
      u.target && !o.current && I(X, n, { originalEvent: u }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", r), () => e.removeEventListener("focusin", r);
  }, [e, n]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function L() {
  const t = new CustomEvent(m);
  document.dispatchEvent(t);
}
function I(t, e, n, { discrete: o }) {
  const r = n.originalEvent.target, u = new CustomEvent(t, { bubbles: !1, cancelable: !0, detail: n });
  e && r.addEventListener(t, e, { once: !0 }), o ? M(r, u) : r.dispatchEvent(u);
}
var Z = T, ee = F;
export {
  ee as B,
  T as D,
  Z as R
};
//# sourceMappingURL=index.DNGle7LJ.js.map
